module.exports = function() {
  return new Worker(__webpack_public_path__ + "b99dc99a1f981614e9f8.worker.js");
};